var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1718701060238,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4423,
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M385.28 432.64a38.4 35.84 90 1 0 71.68 0 38.4 35.84 90 1 0-71.68 0zM477.44 608l-56.32-81.92-89.6 136.96h360.96L584.96 448z",
    fill: "#bfbfbf",
    "p-id": 4424
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 0C229.12 0 0 229.12 0 512s229.12 512 512 512 512-229.12 512-512S794.88 0 512 0z m230.4 678.4c0 28.16-23.04 51.2-51.2 51.2H332.8c-28.16 0-51.2-23.04-51.2-51.2V345.6c0-28.16 23.04-51.2 51.2-51.2h358.4c28.16 0 51.2 23.04 51.2 51.2v332.8z",
    fill: "#bfbfbf",
    "p-id": 4425
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photo-icon.67b4940bc7fdd1457862b30d7aae4146.svg";
export { ForwardRef as ReactComponent };